import { Injectable } from '@angular/core';
import { databases, ID } from '../config/appwrite';
import { environment } from '../../../environments/environment';
import { Query } from 'appwrite';
import { Convenio } from '../models';

@Injectable({
  providedIn: 'root'
})
export class ConvenioService {
  private collectionId = "convenios";
  private DATABASE_NAME = environment.databaseName;

  constructor() { }


  /**
   *getConvenios
   * @returns
   */
  getConvenios() {
    return databases.listDocuments(
      this.DATABASE_NAME,
      this.collectionId
    );
  }

  /**
   * @createDocument()
   * @param data
   * @returns
   */
  createDocument(data: Convenio) {
    return databases.createDocument(this.DATABASE_NAME, this.collectionId, ID.unique(), data);
  }

  getDocument(idDocument: string) {
    return databases.getDocument(this.DATABASE_NAME, this.collectionId, idDocument);
  }
  
  /**
 * @getDocuments()
 * @param idEspecialista
 * @returns
 */
  getConveniosEmpresa(idEmpresa: string): Promise<Convenio[]> {
    return databases.listDocuments<Convenio>(
      this.DATABASE_NAME,
      this.collectionId,
      [Query.equal('idEmpresa', [idEmpresa])]
    ).then(response => response.documents);
  }

  /**
   * @getDocuments()
   * @param idEspecialista
   * @returns
   */
  getConveniosEmpresaActive(idEmpresa: string): Promise<Convenio[]> {
    let firstDate = new Date();
    firstDate.setHours(0, 0, 0, 0);

    return databases.listDocuments<Convenio>(
      this.DATABASE_NAME,
      this.collectionId,
      [Query.equal('idEmpresa', [idEmpresa]),
      Query.lessThan('fInicioConvenio', firstDate.toISOString()),
      Query.greaterThan('fFinalizacionConvenio', firstDate.toISOString())
      ]
    ).then(response => response.documents);
  }

}
